(function () {
  "use strict";
  var PE = window.PE || {};
  var $ = function (id) { return document.getElementById(id); };
  var loc = PE.locale || "nl-BE";
  var cur = PE.currency || "EUR";
  var money0 = new Intl.NumberFormat(loc, { style: "currency", currency: cur, maximumFractionDigits: 0 });
  var money2 = new Intl.NumberFormat(loc, { style: "currency", currency: cur, minimumFractionDigits: 2 });
  var cents = function (c) { return (c % 100 === 0 ? money0 : money2).format(c / 100); };
  var esc = function (s) { return String(s).replace(/[<>&"]/g, function (c) { return { "<": "&lt;", ">": "&gt;", "&": "&amp;", '"': "&quot;" }[c]; }); };
  var kwh = function (n) { return n.toLocaleString(loc, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };

  /* ---------- Kleurmodus ---------- */
  (function () {
    var root = document.documentElement, mq = matchMedia("(prefers-color-scheme: light)");
    var btn = $("themeBtn"), btn2 = $("themeBtn2");
    var now = function () { return root.dataset.theme || (mq.matches ? "light" : "dark"); };
    var paint = function () {
      var l = now() === "light";
      if ($("icoSun")) { $("icoSun").style.display = l ? "none" : ""; $("icoMoon").style.display = l ? "" : "none"; }
      if (btn) btn.setAttribute("aria-label", l ? "Schakel naar donkere modus" : "Schakel naar lichte modus");
      if (btn2) { btn2.setAttribute("role", "switch"); btn2.setAttribute("aria-checked", String(l)); $("themeTxt").textContent = "Lichte modus"; }
    };
    var toggle = function () {
      var n = now() === "light" ? "dark" : "light";
      root.dataset.theme = n;
      try { localStorage.setItem("pe-theme", n); } catch (e) {}
      paint();
    };
    if (btn) btn.addEventListener("click", toggle);
    if (btn2) btn2.addEventListener("click", toggle);
    if (mq.addEventListener) mq.addEventListener("change", paint);
    paint();
  })();

  /* ---------- Mobiel menu ---------- */
  (function () {
    var mb = $("menuBtn"), mm = $("mobileMenu");
    if (!mb || !mm) return;
    var set = function (open) {
      mm.hidden = !open; mb.setAttribute("aria-expanded", String(open));
      mb.setAttribute("aria-label", open ? "Menu sluiten" : "Menu openen");
    };
    mb.addEventListener("click", function () { set(mm.hidden); });
    mm.addEventListener("click", function (e) { if (e.target.closest("a")) set(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !mm.hidden) { set(false); mb.focus(); } });
    document.addEventListener("click", function (e) { if (!mm.hidden && !e.target.closest("#mobileMenu, #menuBtn")) set(false); });
  })();

  /* ---------- Bebat-bijdrage ---------- */
  var BB = PE.bebat || { on: false, amounts: {} };
  var bbLabel = BB.label || "Bebat-bijdrage";
  function bebatPer(handle) { return BB.on ? (BB.amounts[handle] || 0) : 0; }
  function bebatProps(perUnit) {
    if (!perUnit) return undefined;
    var p = {}; p[bbLabel] = "waarvan " + money2.format(perUnit / 100) + " per stuk, incl. btw"; p._bebat = perUnit;
    return p;
  }

  /* ---------- Winkelmand ---------- */
  var toastT;
  function toast(t) {
    var el = $("toast"); if (!el) return;
    el.textContent = t; el.classList.add("show");
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove("show"); }, 2000);
  }
  function openCart() {
    $("drawer").classList.add("open"); $("scrim").classList.add("open"); $("drawer").setAttribute("aria-hidden", "false");
    refreshCart();
  }
  function closeCart() {
    $("drawer").classList.remove("open"); $("scrim").classList.remove("open"); $("drawer").setAttribute("aria-hidden", "true");
  }
  function getJSON(url, opts) {
    return fetch(url, Object.assign({ headers: { "Content-Type": "application/json", Accept: "application/json" } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function drawCart(cart) {
    $("cartCount").textContent = cart.item_count;
    var body = $("drBody"), foot = $("drFoot");
    if (!cart.item_count) {
      body.innerHTML = '<div class="empty"><img src="' + PE.mark + '" alt="" width="72" height="86"><p>Je winkelmand is nog leeg.</p><a class="btn btn-ghost" href="/#winkel" data-close>Bekijk de batterijen</a></div>';
      foot.innerHTML = "";
      return;
    }
    var bbTotal = 0;
    body.innerHTML = cart.items.map(function (i) {
      var meta = i.product_has_only_default_variant ? "" : esc(i.variant_title || "");
      var bb = i.properties && +i.properties._bebat;
      if (bb) { bbTotal += bb * i.quantity; meta += (meta ? " · " : "") + "incl. " + money2.format(bb * i.quantity / 100) + " " + esc(bbLabel); }
      return '<div class="line-item"><span class="nm">' + esc((PE.names || {})[i.handle] || i.product_title) + (i.quantity > 1 ? " × " + i.quantity : "") + '</span><span class="lp">' + cents(i.final_line_price) + '</span><span class="meta">' + meta + '</span><button class="rm" type="button" data-rm="' + esc(i.key) + '">Verwijderen</button></div>';
    }).join("");
    foot.innerHTML =
      '<div class="tot grand"><span>Totaal</span><span>' + cents(cart.total_price) + '</span></div>' +
      (bbTotal ? '<div class="tot" style="color:var(--muted)"><span>waarvan ' + esc(bbLabel) + '</span><span>' + money2.format(bbTotal / 100) + '</span></div>' : '') +
      '<p class="cfg-note">Incl. btw. Verzending en betaling (Bancontact, kaart …) regel je bij het afrekenen.</p>' +
      '<a class="btn btn-primary" href="/checkout">Afrekenen</a>' +
      '<a class="btn btn-ghost" href="' + (PE.routes.cartPage || "/cart") + '">Winkelmand bekijken</a>';
  }
  function refreshCart() { return getJSON(PE.routes.cart).then(drawCart).catch(function () {}); }
  function addItems(items, label) {
    return getJSON(PE.routes.cartAdd, { method: "POST", body: JSON.stringify({ items: items }) })
      .then(function () { toast(label + " toegevoegd"); openCart(); })
      .catch(function (e) { toast((e && e.description) || "Toevoegen lukte niet. Probeer het opnieuw."); });
  }
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (t.closest("#openCart")) { e.preventDefault(); openCart(); return; }
    if (t.closest("#closeCart") || t.id === "scrim" || t.closest("[data-close]")) { closeCart(); return; }
    var rm = t.closest("[data-rm]");
    if (rm) {
      rm.disabled = true;
      getJSON(PE.routes.cartChange, { method: "POST", body: JSON.stringify({ id: rm.dataset.rm, quantity: 0 }) }).then(drawCart);
    }
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

  /* ---------- Modeltabs (productfamilie) ---------- */
  document.querySelectorAll(".fam-tabs:not(.is-static)").forEach(function (bar) {
    var card = bar.closest(".prod"), panels = Array.prototype.slice.call(card.querySelectorAll(".prod-panel"));
    function show(i, focus) {
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      Array.prototype.forEach.call(bar.children, function (b, j) {
        b.setAttribute("aria-selected", String(j === i)); b.tabIndex = j === i ? 0 : -1;
        if (j === i && focus) b.focus();
      });
    }
    var start = 0;
    panels.forEach(function (p, i) {
      if (!p.hidden) start = i;
      var b = document.createElement("button");
      b.type = "button"; b.setAttribute("role", "tab"); b.textContent = p.dataset.tab;
      b.addEventListener("click", function () { show(i); });
      b.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();
          show((i + (e.key === "ArrowRight" ? 1 : panels.length - 1)) % panels.length, true);
        }
      });
      bar.appendChild(b);
    });
    show(start);
  });

  /* ---------- Productconfigurator (startpagina) ---------- */
  document.querySelectorAll("[data-config]").forEach(function (card) {
    var variants = [];
    try { variants = JSON.parse(card.querySelector("[data-variants]").textContent); } catch (e) {}
    var mode = card.dataset.mode, max = +card.dataset.max || 3, cap = parseFloat(card.dataset.cap) || 0;
    var n = mode === "variants" ? Math.min(variants.length, (+card.dataset.start || 0) + 1) : 1;
    var limit = mode === "variants" ? variants.length : max;
    var out = card.querySelector("[data-qty]"), priceEl = card.querySelector("[data-price]"), capEl = card.querySelector("[data-cap-out]");
    var bars = card.querySelector("[data-bars]"), art = card.querySelector("[data-art-d]");
    var addons = card.querySelectorAll("[data-addon]");
    var bbEl = card.querySelector("[data-bebat]"), bbStep = bebatPer(card.dataset.handle);
    function bebatUnit() { return mode === "variants" ? bbStep * count() : bbStep; }
    function variant() { return mode === "variants" ? variants[n - 1] : variants[0]; }
    function count() {
      if (mode !== "variants") return n;
      var m = parseInt((variant() || {}).title, 10);
      return isNaN(m) ? n : m;
    }
    function drawArt(k) {
      if (!art) return;
      var mods = art.querySelector(".vd-mods"); if (!mods) return;
      var have = mods.children.length;
      while (have < k) {
        var im = document.createElement("img");
        im.src = art.dataset.mod; im.alt = ""; im.width = 656; im.height = 173; im.className = "vd-new";
        mods.insertBefore(im, mods.firstChild); have++;
      }
      while (have > k) { mods.removeChild(mods.firstChild); have--; }
      art.style.setProperty("--n", k);
    }
    function render() {
      var v = variant(); if (!v) return;
      var k = count();
      var base = mode === "variants" ? v.price : v.price * n;
      var extra = 0; addons.forEach(function (a) { if (a.checked) extra += +a.dataset.addonPrice; });
      out.textContent = mode === "variants" ? k : n;
      priceEl.textContent = cents(base + extra);
      if (capEl && cap) capEl.textContent = kwh(cap * k) + " kWh totaal · incl. btw";
      if (bbEl) {
        var bbt = mode === "variants" ? bebatUnit() : bbStep * n;
        bbEl.hidden = !bbt;
        if (bbt) bbEl.textContent = "waarvan " + money2.format(bbt / 100) + " " + bbLabel;
      }
      if (bars) bars.innerHTML = Array.from({ length: Math.max(6, variants.length) }, function (_, i) { return '<span class="' + (i < k ? "on" : "") + '"></span>'; }).join("");
      drawArt(Math.max(1, Math.min(k, 6)));
      card.querySelectorAll("[data-d]").forEach(function (b) { var d = +b.dataset.d; b.disabled = (d < 0 && n <= 1) || (d > 0 && n >= limit); });
      var add = card.querySelector("[data-add]");
      if (add) { add.disabled = !v.available; add.textContent = v.available ? "In winkelmand" : "Uitverkocht"; }
    }
    card.querySelectorAll("[data-d]").forEach(function (b) {
      b.addEventListener("click", function () { n = Math.min(limit, Math.max(1, n + +b.dataset.d)); render(); });
    });
    addons.forEach(function (a) { a.addEventListener("change", render); });
    var add = card.querySelector("[data-add]");
    if (add) add.addEventListener("click", function () {
      var v = variant(); if (!v) return;
      var items = [{ id: v.id, quantity: mode === "variants" ? 1 : n, properties: bebatProps(bebatUnit()) }];
      addons.forEach(function (a) { if (a.checked) items.push({ id: +a.dataset.addon, quantity: 1 }); });
      add.disabled = true;
      addItems(items, card.dataset.name).then(function () { add.disabled = false; });
    });
    render();
  });

  /* ---------- Productfoto's ---------- */
  document.querySelectorAll(".thumb").forEach(function (b, i, all) {
    if (i === 0) b.setAttribute("aria-current", "true");
    b.addEventListener("click", function () {
      var img = $("pdpMain"); if (!img) return;
      img.removeAttribute("srcset"); img.src = b.dataset.full;
      all.forEach(function (x) { x.setAttribute("aria-current", String(x === b)); });
    });
  });

  /* ---------- Productpagina ---------- */
  (function () {
    var form = $("pdpForm"); if (!form) return;
    var variants = [];
    try { variants = JSON.parse(form.querySelector("[data-variants]").textContent); } catch (e) {}
    var priceEl = document.querySelector("[data-pdp-price]"), btn = form.querySelector('[name="add"]');
    form.addEventListener("change", function (e) {
      if (e.target.name !== "id") return;
      var v = variants.filter(function (x) { return x.id === +e.target.value; })[0];
      if (!v) return;
      priceEl.textContent = cents(v.price);
      btn.disabled = !v.available; btn.textContent = v.available ? "In winkelmand" : "Uitverkocht";
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var idEl = form.querySelector('[name="id"]:checked') || form.querySelector('[name="id"]');
      var qty = Math.max(1, +form.querySelector('[name="quantity"]').value || 1);
      var items = [{ id: +idEl.value, quantity: qty }];
      form.querySelectorAll("[data-addon]").forEach(function (a) { if (a.checked) items.push({ id: +a.dataset.addon, quantity: 1 }); });
      btn.disabled = true;
      addItems(items, document.querySelector(".pdp-info h1").textContent.trim()).then(function () { btn.disabled = false; });
    });
  })();

  /* ---------- Besparingscalculator ---------- */
  (function () {
    var root = document.querySelector("[data-savings]"); if (!root) return;
    var pressed = root.querySelector('[data-cap][aria-pressed="true"]');
    var cap = pressed ? +pressed.dataset.cap : 5.12, mode = "dyn", EFF = 0.9, USABLE = 0.89;
    var ppk = function (v) { return money2.format(v) + " /kWh"; };
    root.querySelectorAll("[data-cap]").forEach(function (b) {
      b.addEventListener("click", function () { cap = +b.dataset.cap; root.querySelectorAll("[data-cap]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); }); est(); });
    });
    root.querySelectorAll("[data-mode]").forEach(function (b) {
      b.addEventListener("click", function () {
        mode = b.dataset.mode;
        root.querySelectorAll("[data-mode]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        $("panelDyn").hidden = mode !== "dyn"; $("panelSun").hidden = mode !== "sun"; est();
      });
    });
    function est() {
      var yearly, net;
      if (mode === "dyn") {
        var use = +$("peakUse").value, lo = +$("pLow").value, hi = +$("pHigh").value;
        $("peakUseOut").textContent = use.toLocaleString(loc) + " kWh"; $("pLowOut").textContent = ppk(lo); $("pHighOut").textContent = ppk(hi);
        yearly = Math.min(use, cap * USABLE) * 330; net = Math.max(0, hi - lo / EFF);
        $("estFine").textContent = "Gaat uit van één volle laadbeurt per dag op 330 dagen en 90% rendement: per kWh die je 's avonds gebruikt, koop je ongeveer 1,11 kWh in de goedkope uren. Het voordeel op je capaciteitstarief komt hier nog bovenop.";
      } else {
        var sur = +$("surplus").value, pr = +$("kwhPrice").value, fi = +$("feedin").value;
        $("surplusOut").textContent = sur.toLocaleString(loc) + " kWh"; $("priceOut").textContent = ppk(pr); $("feedOut").textContent = ppk(fi);
        yearly = Math.min(sur, cap * USABLE) * EFF * 280; net = Math.max(0, pr - fi);
        $("estFine").textContent = "Gaat uit van 280 nuttige laaddagen en 90% rendement. Je werkelijke besparing hangt af van je tarief, je verbruik en het weer.";
      }
      $("shifted").textContent = Math.round(yearly).toLocaleString(loc) + " kWh";
      $("spread").textContent = money2.format(net);
      $("yearSave").textContent = money0.format(Math.round(yearly * net));
    }
    ["surplus", "kwhPrice", "feedin", "peakUse", "pLow", "pHigh"].forEach(function (id) { $(id).addEventListener("input", est); });
    est();
  })();

  /* ---------- Hero-dagcurve ---------- */
  (function () {
    if (!document.querySelector("[data-hero-curve]")) return;
    var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
    var PR = [.07, .05, .04, .03, .03, .05, .10, .18, .20, .14, .06, .01, -.04, -.07, -.05, .01, .09, .17, .23, .25, .21, .15, .11, .09];
    var CH = [2, 3, 4, 12, 13, 14], DIS = [7, 8, 18, 19, 20];
    var has = function (a, h) { return a.indexOf(h) > -1; };
    var socD = [34, 34, 55, 76, 96, 96, 96, 72, 48, 48, 48, 48, 66, 84, 100, 100, 100, 100, 78, 56, 34, 34, 34, 34];
    /* Percentage vloeiend laten tellen in plaats van te verspringen */
    var socShown = null, socRaf = 0;
    function setSoc(target) {
      var el = $("soc"); if (!el) return;
      cancelAnimationFrame(socRaf);
      if (socShown === null || reduce) { socShown = target; el.textContent = target + "%"; return; }
      var from = socShown, t0 = performance.now(), dur = 900;
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        socShown = Math.round(from + (target - from) * e);
        el.textContent = socShown + "%";
        if (k < 1) socRaf = requestAnimationFrame(step);
      })(t0);
    }
    var X0 = 34, W = 430 / 24, yOf = function (p) { return 186 - (p + .10) / .38 * 162; }, y0 = yOf(0);
    var lab = function (p) { return (p < 0 ? "−" : "") + Math.abs(p).toFixed(2).replace(".", ","); };
    var s = '<g style="stroke:var(--ink)" stroke-opacity=".1">';
    [-.05, .10, .20].forEach(function (p) { s += '<line x1="' + X0 + '" x2="466" y1="' + yOf(p) + '" y2="' + yOf(p) + '"/>'; });
    s += '</g><line style="stroke:var(--ink)" stroke-opacity=".45" x1="' + X0 + '" x2="466" y1="' + y0 + '" y2="' + y0 + '"/>';
    s += '<g style="fill:var(--muted)" font-size="10" font-family="JetBrains Mono, monospace" text-anchor="end">';
    [-.05, 0, .10, .20].forEach(function (p) { s += '<text x="' + (X0 - 4) + '" y="' + (yOf(p) + 3) + '">' + lab(p) + '</text>'; });
    s += '</g>';
    PR.forEach(function (p, h) {
      var c = has(CH, h) ? "sun" : has(DIS, h) ? "ink" : "line";
      var top = Math.min(yOf(p), y0), hgt = Math.max(1.5, Math.abs(yOf(p) - y0));
      s += '<rect style="fill:var(--' + c + ')" x="' + (X0 + h * W + 1.5) + '" y="' + top + '" width="' + (W - 3) + '" height="' + hgt + '" rx="2"/>';
    });
    s += '<g style="fill:var(--muted)" font-size="10" font-family="JetBrains Mono, monospace" text-anchor="middle">';
    [0, 6, 12, 18, 23].forEach(function (h) { s += '<text x="' + (X0 + h * W + W / 2) + '" y="208">' + String(h).padStart(2, "0") + 'u</text>'; });
    s += '</g><text style="fill:var(--accent-fg)" x="' + (X0 + 3 * W + W / 2) + '" y="' + (yOf(.05) - 8) + '" text-anchor="middle" font-size="11" font-family="JetBrains Mono, monospace">laden</text>';
    s += '<text style="fill:var(--accent-fg)" x="' + (X0 + 13 * W + W / 2) + '" y="' + (yOf(-.07) + 13) + '" text-anchor="middle" font-size="11" font-family="JetBrains Mono, monospace">betaald laden</text>';
    s += '<text style="fill:var(--ink)" x="' + (X0 + 19 * W + W / 2) + '" y="' + (yOf(.25) - 8) + '" text-anchor="middle" font-size="11" font-family="JetBrains Mono, monospace">ontladen</text>';
    s += '<rect id="dynNow" style="fill:none;stroke:var(--sun)" x="0" y="16" width="' + W + '" height="' + (yOf(-.07) + 2 - 16) + '" rx="3" stroke-width="1.5"/>';
    $("dynSvg").innerHTML = s;
    var view = "dyn", hr = 13;
    var sunY = function (x) { return x < 148 || x > 387 ? 190 : 190 - 150 * Math.sin(Math.PI * (x - 148) / 239); };
    var SOCS = [40, 40, 40, 40, 40, 40, 34, 24, 14, 10, 22, 38, 55, 71, 85, 95, 100, 100, 90, 76, 62, 52, 44, 40];
    var socS = function (h) { return SOCS[h]; };
    function tick() {
      var hh = String(hr).padStart(2, "0") + ":00 · ";
      if (view === "dyn") {
        $("dynNow").setAttribute("x", X0 + hr * W);
        var m = !has(CH, hr) ? (has(DIS, hr) ? "ontladen, net kost " + money2.format(PR[hr]) : "stand-by")
          : PR[hr] < 0 ? "laden én " + money2.format(-PR[hr]) + " per kWh krijgen" : "laden aan " + money2.format(PR[hr]);
        setSoc(socD[hr]); $("clock").textContent = hh + m;
      } else {
        var x = 20 + (hr / 24) * 440;
        $("nowLine").setAttribute("x1", x); $("nowLine").setAttribute("x2", x);
        $("nowDot").setAttribute("cx", x); $("nowDot").setAttribute("cy", sunY(x) - 4);
        var m2 = hr >= 6 && hr <= 8 ? "ochtendpiek: voedt je woning" : hr === 9 ? "zon neemt over" : hr >= 10 && hr <= 15 ? "laden met zonne-overschot" : hr === 16 || hr === 17 ? "vol, overschot gaat naar het net" : hr >= 18 && hr <= 22 ? "avondpiek: voedt je woning" : "stand-by, reserve voor de ochtend";
        setSoc(Math.round(socS(hr))); $("clock").textContent = hh + m2;
      }
    }
    document.querySelectorAll("[data-view]").forEach(function (b) {
      b.addEventListener("click", function () {
        view = b.dataset.view;
        document.querySelectorAll("[data-view]").forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        $("dynSvg").toggleAttribute("hidden", view !== "dyn"); $("sunSvg").toggleAttribute("hidden", view !== "sun");
        $("legDyn").hidden = view !== "dyn"; $("legSun").hidden = view !== "sun";
        $("curveTitle").textContent = view === "dyn" ? "Uurprijzen op een gewone dag" : "Een zonnige dag";
        tick();
      });
    });
    tick();
    if (!reduce) setInterval(function () { hr = (hr + 1) % 24; tick(); }, 1100);
  })();
})();
